<template>
  <div class="container-fluid">
    <el-form v-if="!submited" @submit.prevent.native="setNewPassword" class="login" :model="form" label-width="110px" :rules="formRules" ref="form">
      <h1>
        Nastavení hesla
      </h1>
      <el-form-item label="Nové heslo" prop="password">
        <el-input
            placeholder="Zadejte nové heslo"
            v-model="form.password"
            show-password
          ></el-input>
      </el-form-item>
      <el-form-item label="Potvrďte heslo" prop="repeatPassword">
        <el-input
            placeholder="Potvrďte heslo"
            v-model="form.repeatPassword"
            show-password
          ></el-input>
      </el-form-item>

      <div class="mb-4" v-if="error.length">
        <p style="color: red">
          {{ error }}
        </p>
      </div>

      <div class="mb-4">
        <el-button native-type="submit">
          Uložit
        </el-button>
      </div>

      <div class="mb-4">
        <router-link
          :to="{
            name: 'login'
          }"
        >
          Vrátit se na přihlášení
        </router-link>
      </div>

      <div class="mb-4" v-if="error.length">
        <router-link :to="{
          name: 'resetPassword'
        }">
          Změna nebo obnovení hesla
        </router-link>
      </div>
    </el-form>

    <h1 style="text-align: center" v-if="submited">
      Heslo bylo úspěšně nastaveno. Můžete
      <router-link
        :to="{
          name: 'login'
        }"
      >se přihlásit</router-link>.
    </h1>
  </div>
</template>

<script>
export default {
  name: 'SetPassword',
  data() {
    var checkPass = (rule, value, callback) => {
      let regEx = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{12,}$/g
      if (!value) {
        return callback(new Error('Je to povinné pole'))
      } else if (!regEx.test(value)) {
        return callback(new Error('Minimálně 12 znaků. 1 malé a velké písmeno, jedna číslice'))
      } else {
        if (this.formRules.password !== '') {
          this.$refs.form.validateField('repeatPassword');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Zadejte heslo znovu'));
      } else if (value !== this.form.password) {
        callback(new Error('Hesla nejsou stejná'));
      } else {
        callback();
      }
    };
    return {
      form: {
        password: '',
        repeatPassword: '',
        token: '',
        id: '',
      },
      error: '',
      submited: false,
      formRules: {
        password: { validator: checkPass, trigger: 'blur' },
        repeatPassword: { validator: validatePass2, trigger: 'blur' },
      }
    }
  },
  methods: {
    setNewPassword() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$store.dispatch('setPassword', this.form)
            .then(response => {
              this.submited = true
            })
            .catch(error => {
              this.error = 'Máte neplatnou relaci. Požadejte o změnu hesla znovu.'
            })
        } else {
          return false
        }
      })
    }
  },
  mounted() {
    this.form.id = this.$route.query.user
    this.form.token = this.$route.query.token
  }
}
</script>

<style scoped>
.login {
  margin-top: 100px;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}
</style>
